/* Progressive enhancement only. Shopify's native product form owns cart submission. */
(() => {
  if (customElements.get('pb-spine-landing')) return;
  customElements.define('pb-spine-landing', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.abortController = new AbortController();
      const signal = this.abortController.signal;
      const variantField = this.querySelector('[data-pb-variant]');
      const variantData = this.querySelector('[data-pb-variants]');
      let variants = [];
      try { variants = JSON.parse(variantData?.textContent || '[]'); } catch (_) { /* Keep native form. */ }
      const sync = () => {
        const variant = variants.find(item => String(item.id) === variantField?.value);
        if (!variant) return;
        const price = this.querySelector('[data-pb-price]');
        const compare = this.querySelector('[data-pb-compare]');
        const button = this.querySelector('[data-pb-add]');
        const quantity = this.querySelector('[data-pb-quantity]');
        const status = this.querySelector('[data-pb-availability]');
        if (price) price.textContent = variant.price;
        if (compare) { compare.textContent = variant.compare; compare.hidden = !variant.compare; }
        if (button) { button.disabled = !variant.available; button.textContent = variant.available ? this.dataset.addLabel : this.dataset.soldLabel; }
        if (status) status.textContent = variant.available ? '' : 'This option is currently unavailable.';
        if (quantity) {
          quantity.min = String(variant.min || 1);
          quantity.step = String(variant.step || 1);
          if (variant.max != null) quantity.max = String(variant.max); else quantity.removeAttribute('max');
          if (!quantity.checkValidity()) quantity.value = quantity.min;
        }
      };
      variantField?.addEventListener('change', sync, { signal });
      sync();
      // Show a mobile reminder only after the hero, and hide it around the purchase form.
      const sticky = this.querySelector('[data-pb-sticky]');
      const hero = this.querySelector('.pb-spine__hero');
      const buy = this.querySelector('.pb-spine__buy');
      const updateSticky = () => {
        if (!sticky || !hero || !buy) return;
        const rect = buy.getBoundingClientRect();
        const buyingVisible = rect.top < window.innerHeight && rect.bottom > 0;
        sticky.hidden = hero.getBoundingClientRect().bottom > 0 || buyingVisible;
      };
      if (sticky && 'IntersectionObserver' in window) {
        this.visibilityObserver = new IntersectionObserver(updateSticky, { threshold: [0, 1] });
        this.visibilityObserver.observe(hero);
        this.visibilityObserver.observe(buy);
        window.addEventListener('resize', updateSticky, { signal });
        updateSticky();
      }
    }
    disconnectedCallback() {
      this.abortController?.abort();
      this.visibilityObserver?.disconnect();
      this.initialized = false;
    }
  });
})();
